import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Switch, Tooltip } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { ProTag } from "../common/proTag.js";
const OptionsPostTypesRow = observer(({ name })=>{
    const { message, modal } = App.useApp();
    const { optionStore } = useStores();
    const { others: { postTypes, isPro, pluginCptUi } } = optionStore;
    const { label, link, available, active, fastMode } = postTypes[name];
    const handleUpdatePostTypeActive = useCallback(async (state)=>{
        await optionStore.updatePostTypeOptions(name, {
            active: state
        });
        message.success(state ? __("Category tree enabled for %s.", label) : __("Category tree disabled for %s.", label));
    }, [
        optionStore,
        label,
        message
    ]);
    const handleUpdatePostTypeFastMode = useCallback(async (state)=>{
        await optionStore.updatePostTypeOptions(name, {
            fastMode: state
        });
        message.success(state ? __("Pagination without reloading the page enabled for %s.", label) : __("Pagination without reloading the page disabled for %s.", label));
    }, [
        optionStore,
        label,
        message
    ]);
    const handleCreateCustomPostType = useCallback(async ()=>{
        if (!pluginCptUi.active) {
            modal.confirm({
                cancelText: __("Cancel"),
                okText: "Continue",
                title: __("Custom Post Type UI"),
                content: __("To create custom taxonomies we highly recommend to use the 3rd party plugin Custom Post Type UI. Would you like to install and activate it now?"),
                onOk: async ()=>{
                    await optionStore.installAndActivateCustomPostTypeUI();
                    window.location.href = pluginCptUi.manageTaxonomiesUrl;
                }
            });
        } else {
            window.location.href = pluginCptUi.manageTaxonomiesUrl;
        }
    }, [
        optionStore,
        pluginCptUi
    ]);
    return /*#__PURE__*/ _jsxs("tr", {
        children: [
            /*#__PURE__*/ _jsxs("td", {
                children: [
                    /*#__PURE__*/ _jsx("strong", {
                        children: label
                    }),
                    " •",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: link,
                        target: "_blank",
                        rel: "noreferrer",
                        children: __("Open")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                children: name !== "post" && !isPro ? /*#__PURE__*/ _jsx(ProTag, {
                    feature: "options-active"
                }) : available ? /*#__PURE__*/ _jsx(Switch, {
                    checked: active,
                    onChange: handleUpdatePostTypeActive
                }) : /*#__PURE__*/ _jsx(Tooltip, {
                    placement: "top",
                    title: __("There are no taxonomies available for this post type. You need to register your own taxonomy so that you can organize your content into its categories."),
                    children: /*#__PURE__*/ _jsx("button", {
                        className: "button",
                        onClick: handleCreateCustomPostType,
                        children: __("Create custom taxonomy")
                    })
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx(Switch, {
                    checked: active && fastMode,
                    disabled: !active || !isPro,
                    onChange: handleUpdatePostTypeFastMode
                })
            })
        ]
    });
});
export { OptionsPostTypesRow };
